import { PrimusClient, PrimusClientParams } from './PrimusClient'

const initializePrimusClient = async (params: PrimusClientParams): Promise<PrimusClient> => {
    const primusClient = new PrimusClient(params)

    return primusClient.resolveOnOpen()
}

export { PrimusClient, initializePrimusClient }
